import { omit } from 'lodash'
import { API_CONST } from '../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { generateActions } from '../utils'
import { reformatLot } from '../../selectors/lots'

const initial = {
  result: {
    funds: [],
    //persons: [],
    //lots: []
    externalpartners: [],
    actions: []
  }
}

const actions = generateActions('search/SEARCH')

export const search = createAction(
  API_CONST,
  query => ({
    actions,
    params: { query },
    url: 'search'
  })
)

export const clear = createAction('search/CLEAR')

export default handleActions({
  [clear]: state => ({ ...initial }),
  [actions[0]]: state => ({ ...initial }),
  [actions[1]]: (state, { payload }) => {//результаты поиска - persons и lots не нужны на лендинге
    let result = payload
    delete result.persons
    delete result.lots

    return ({ ...state, result })
  },
  [actions[2]]: state => ({ ...initial })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/search.js